export default __webpack_public_path__ + "static/media/comment-checked.6b1831e2.svg";